import moment from 'moment';
import defaultStyles from './styles/defaults';

const defaultOptions = [
  {
    label: 'Today',
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day')
  },
  {
    label: 'Yesterday',
    startDate: moment().subtract(1, 'days'),
    endDate: moment().subtract(1, 'days')
  },
  {
    label: 'Last 7 Days',
    startDate: moment()
      .subtract(7, 'days')
      .startOf('day'),
    endDate: moment().endOf('day')
  },
  {
    label: 'Last 30 Days',
    startDate: moment()
      .subtract(30, 'days')
      .startOf('day'),
    endDate: moment().endOf('day')
  },
  {
    label: 'This Month',
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month')
  },
  {
    label: 'Last Month',
    startDate: moment()
      .subtract(1, 'months')
      .startOf('month'),
    endDate: moment()
      .subtract(1, 'months')
      .endOf('month')
  }
];

export { defaultOptions, defaultStyles };
